export const shouldGenerateWordComment = (comment: string) => {
  let shouldGenerateComments = true;

  if (typeof Office !== "undefined" && Office.context && Office.context.document && Office.context.document.settings) {
    const settingValue = Office.context.document.settings.get(comment);

    if (settingValue === false || settingValue === "false") {
      shouldGenerateComments = false;
    }
  }

  return shouldGenerateComments;
};
